import BN from "bignumber.js";

export default value => {
  return new BN(value).toFormat(2, BN.ROUND_HALF_CEIL);
};
